module.exports = __webpack_public_path__ + "static/media/sleepearn_bg.c15ad9d6.jpg";